module.exports = __webpack_public_path__ + "img/cspace-phonesupport.2c821726.svg";